import React from "react";
import ReactDOM from "react-dom";
import "mueller-controls/dist/src/mueller-controls.css";
import "./index.scss";
import PolicyHolderBooking from "pages/policyHolderBooking";
import PolicyHolderBookingV2 from "pages/policyHolderBookingV2";
import { materialUITheme } from "mueller-controls";
import { StylesProvider } from "@mui/styles";
import { ThemeProvider } from "@mui/material/styles";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import config from "utilities/config";
import LandingPage from "pages/LandingPage";

ReactDOM.render(
  <StylesProvider injectFirst>
    <ThemeProvider theme={materialUITheme}>
      <React.StrictMode>
        <BrowserRouter basename={config.baseName}>
          <Routes>
            <Route path="set-appointment-v2/:workItemId/:campaign/:routeKey" element={<PolicyHolderBookingV2 />} />
            <Route path="set-appointment/:workItemId/:campaign/:routeKey" element={<PolicyHolderBooking />} />
            <Route path="set-appointment/:workItemId/:campaign" element={<PolicyHolderBooking />} />
            <Route path="" element={<LandingPage />} />
          </Routes>
        </BrowserRouter>
      </React.StrictMode>
    </ThemeProvider>
  </StylesProvider>,
  document.getElementById("mueller-ui-pages-root")
);
